import React, { useEffect, useState, useCallback } from "react";
import BaseButton from "../../BaseComponents/BaseButton";
import BaseSelect from "../../BaseComponents/BaseSelect";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { Submit, SuperAdmin } from "../../Constant";
import { All, checkStatusCodeSuccess, getLocalItem } from "../../Constant/common";
import { toast } from "react-toastify";
import { listOfOrganizationApi } from "../../Api/OrganizationApi";
import { usePageLoader } from "../../_helper/loading/LoadingContext";
import { useSelectedOrganization } from "../OrganizationContext";

const StaffOrganizationConfig = () => {
  const { setLoading } = usePageLoader();
  const navigate = useNavigate();
  const { selectedOrganization: globalOrgId } = useSelectedOrganization();
  const { fromSetting } = useLocation().state || {};
  const [organizationData, setOrganizationData] = useState([]);

  const fetchOrganization = useCallback(async () => {
    const role = getLocalItem("role");
    if (role !== SuperAdmin) return;
    setLoading(true);
    await listOfOrganizationApi({})
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          const data = resp?.data?.listOfOrganizations?.map((item) => ({
            value: String(item.id),
            label: String(item.organization_name),
            id: String(item.id),
          }));
          setOrganizationData(data || []);
        } else {
          setOrganizationData([]);
          toast.error("Failed to load organizations.");
        }
      })
      .catch((err) => {
        setOrganizationData([]);
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setLoading]);

  useEffect(() => {
    fetchOrganization();
  }, [fetchOrganization]);

  const formik = useFormik({
    initialValues: {
      organization: globalOrgId ? String(globalOrgId) : "",
    },
    onSubmit: (values) => {
      const organizationId =
        values.organization === All || !values.organization ? null : Number(values.organization);

      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        navigate(fromSetting !== undefined ? "/setting" : "/staffProfile", {
          state: {
            viewProfileMode: false,
            viewGeneralMode: false,
            viewPersonalMode: false,
            viewEmploymentMode: false,
            viewBankMode: false,
            organizationId,
          },
        });
      }, 500);
    },
  });

  return (
    <div className="card section mb-3 p-4">
      <form onSubmit={formik.handleSubmit}>
        <div className="row justify-content-organization">
          <div className="col-lg-3">
            <BaseSelect
              id="organization"
              name="organization"
              label="Organization"
              className="select-border"
              options={organizationData}
              placeholder="Select Organization"
              handleChange={(field, value) => {
                formik.setFieldValue(field, value);
              }}
              value={formik.values.organization}
              isDisabled={!!globalOrgId}
              touched={formik.touched.organization}
              error={formik.errors.organization}
            />
          </div>
          <div>
            <BaseButton type="submit" className="btn btn-pill btn-primary mx-2">
              {Submit}
            </BaseButton>
          </div>
        </div>
      </form>
    </div>
  );
};

export default StaffOrganizationConfig;
